module.exports = __webpack_public_path__ + "static/media/D8.874f44e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dice/D8.png
// module id = 23
// module chunks = 0